import React from 'react';

const DocumentSearchIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="111"
    height="137"
    viewBox="0 0 111 137"
    {...props}
  >
    <g fill="none">
      <path
        fill="#DDD"
        d="M18.323 62h58.354C79.065 62 81 60.21 81 58s-1.935-4-4.323-4H18.323C15.935 54 14 55.79 14 58s1.935 4 4.323 4zM16.774 80h37.452C55.758 80 57 78.21 57 76s-1.242-4-2.774-4H16.774C15.242 72 14 73.79 14 76s1.242 4 2.774 4zM16.323 98h31.354C48.96 98 50 96.21 50 94s-1.04-4-2.323-4H16.323C15.04 90 14 91.79 14 94s1.04 4 2.323 4z"
        transform="translate(3 3)"
      />
      <path
        stroke="#DDD"
        strokeWidth="5"
        d="M23.772 26.03c-1.252 0-2.086-.868-2.086-2.17V13.015c0-2.386 1.877-4.339 4.172-4.339h3.128c.626 0 1.252-.217 1.669-.867l3.754-5.206C35.661.868 37.538 0 39.415 0h14.6c1.878 0 3.755.868 5.006 2.603l3.755 5.206c.417.65 1.043.867 1.668.867h3.129c2.294 0 4.172 1.953 4.172 4.339V23.86c0 1.302-.835 2.17-2.086 2.17H23.772z"
        transform="translate(3 3)"
      />
      <path
        stroke="#DDD"
        strokeWidth="5"
        d="M81.752 20.898h4.671c3.971 0 7.008 3.036 7.008 7.007v84.088c0 3.97-3.037 7.007-7.008 7.007H7.007C3.037 119 0 115.964 0 111.993V27.905c0-3.97 3.036-7.007 7.007-7.007L10 21c1.401 0 4.015.832 4.015 2.234v4.671c0 3.97 3.036 7.007 7.007 7.007h51.387c3.97 0 7.007-3.036 7.007-7.007v-4.671c0-1.402.934-2.336 2.336-2.336z"
        transform="translate(3 3)"
      />
      <g>
        <path
          fill="#DDD"
          d="M20.706 0c7.824-.01 14.983 4.185 18.5 10.84 3.516 6.656 2.787 14.632-1.883 20.609l11.178 9.004c1.222.994 1.756 2.557 1.38 4.045-.374 1.488-1.594 2.65-3.157 3.007-1.562.357-3.203-.151-4.247-1.315l-9.456-10.644c-7.224 5.099-17.078 5.172-24.385.182C1.33 30.738-1.758 21.825.996 13.674 3.75 5.522 11.716-.004 20.706 0zm0 35.287c9.028 0 16.347-6.97 16.347-15.568 0-8.597-7.319-15.568-16.347-15.568-9.027 0-16.346 6.97-16.346 15.568 0 8.598 7.319 15.568 16.346 15.568z"
          transform="translate(3 3) translate(58 86)"
        />
        <path
          fill="#FFF"
          d="M20.706 35.287c9.028 0 16.347-6.97 16.347-15.568 0-8.597-7.319-15.568-16.347-15.568-9.027 0-16.346 6.97-16.346 15.568 0 8.598 7.319 15.568 16.346 15.568z"
          transform="translate(3 3) translate(58 86)"
        />
      </g>
    </g>
  </svg>
);

export default DocumentSearchIcon;
